import useAxios from 'hooks/useAxios';

/**
 * Get per-user session statistics for a date range
 * @param {Object} params - Query parameters
 * @param {string} params.startDate - Start date (ISO 8601 format)
 * @param {string} params.endDate - End date (ISO 8601 format)
 */
export async function getUserSessions(params) {
  const api = useAxios();

  try {
    const queryParams = new URLSearchParams();
    queryParams.append('startDate', params.startDate);
    queryParams.append('endDate', params.endDate);

    const res = await api.get(
      `/statistics/user-sessions?${queryParams.toString()}`,
    );
    return res;
  } catch (err) {
    return err;
  }
}
